export const FlashMessage = (() => {
	// eslint-disable-next-line no-shadow
	enum FlashMessageType {
		SUCCESS = 'success',
		ERROR = 'error',
		WARNING = 'warning',
		INFO = 'info',
		NOTICE = 'notice',
	}

	const type2styleMap = {
		[FlashMessageType.SUCCESS]: {
			color: 'bg-emerald-600',
			icon: 'check',
		},
		[FlashMessageType.ERROR]: {
			color: 'bg-red-600',
			icon: 'times',
		},
		[FlashMessageType.WARNING]: {
			color: 'bg-yellow-600',
			icon: 'exclamation-triangle',
		},
		[FlashMessageType.INFO]: {
			color: 'bg-blue-600',
			icon: 'info-circle',
		},
		[FlashMessageType.NOTICE]: {
			color: 'bg-gray-600',
			icon: 'info-circle',
		},
	}

	const show = (message: string, type: FlashMessageType = FlashMessageType.SUCCESS) => {
		const style = type2styleMap[type]
		const html = `
        <div>
          <div class="flex items-center">
            <i class="fa-light fa-${style.icon} align-middle pr-3"></i>
            <span>${message}</span>
          </div>
        </div>`

		M.toast({
			html,
			displayLength: 6500,
			classes: style.color,
		})
	}

	return {
		show,
	}
})()
